import React from 'react';

type CustomShapeProps = {
  className?: string;
  children?: React.ReactNode;
};

function CustomShape({ className, children }: CustomShapeProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="63" viewBox="0 0 64 63" fill="none" className={className}>
      <path
        d="M59.9757 4.77638C36.0168 -3.87413 13.1225 1.17204 4.42875 4.77642C-3.59215 28.4425 1.08671 50.2178 4.42875 58.1472C28.2123 66.9361 51.2089 61.8092 59.9757 58.1472C67.2641 36.1105 63.0125 13.3847 59.9757 4.77638Z"
        fill="#FEF1DC"
      />
      {children && (
        <foreignObject x="0" y="0" width="64" height="63">
          <div className="w-full h-full flex items-center justify-center">{children}</div>
        </foreignObject>
      )}
    </svg>
  );
}

export { CustomShape };
